"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Switch;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactNativeSwitch = require("react-native-switch");
function Switch(props) {
  var rest = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(props), props));
  return /*#__PURE__*/_react["default"].createElement(_reactNativeSwitch.Switch, rest);
}